// File: src/components/trends/CreditStreamAnimation.jsx
import React, { useMemo, useEffect } from "react";
import { motion } from "framer-motion";

import likedIcon from "../../assets/trends_liked.png";
import dislikedIcon from "../../assets/trends_disliked.png";
import creditIcon from "../../assets/credit_icon.png";

const getBubbleIcon = (rating) => {
  

  const normalizedRating = typeof rating === "string" ? rating.toLowerCase() : "";

  if (normalizedRating === "liked") {
    
    return likedIcon;
  }
  
  if (normalizedRating === "disliked") {
    
    return dislikedIcon;
  }

  console.warn("⚠️ [CreditStreamAnimation] No match! Falling back to creditIcon");
  return creditIcon;
};

const CreditStreamAnimation = ({ origin, target, rating }) => {
  useEffect(() => {
    
    return () => {
      
    };
  }, []);

  const activeIcon = useMemo(() => getBubbleIcon(rating), [rating]);

  // 🎈 Calculate smooth, buoyant keyframes per bubble
  const bubbleData = useMemo(() => {
    if (!origin || !target) return [];

    
    const deltaX = target.x - origin.x;
    const deltaY = target.y - origin.y;

    return Array.from({ length: 5 }).map((_, i) => {
      // Random lateral drift (-35px to +35px)
      const randomDrift = (Math.random() - 0.5) * 70;
      
      return {
        id: i,
        // Smooth 3-step arc keyframes for X: Start -> Soft Wobble -> Converge at target
        xKeyframes: [0, randomDrift, deltaX],
        // Smooth 3-step arc keyframes for Y: Start -> Rising arc -> Target balance
        yKeyframes: [0, deltaY * 0.4 - 20, deltaY],
        delay: i * 0.12, // Slightly wider delay stagger for organic flow
      };
    });
  }, [origin?.x, origin?.y, target?.x, target?.y]);

  if (!origin || !target || bubbleData.length === 0) return null;

  return (
    <motion.div 
      initial={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.3 }}
      className="absolute inset-0 pointer-events-none z-[9999]"
    >
      {bubbleData.map((bubble) => (
        <motion.img
          key={bubble.id}
          src={activeIcon}
          alt={rating || "Rating"}
          className="w-6 h-6 absolute pointer-events-none"
          style={{
            position: "absolute",
            left: origin.x,
            top: origin.y,
          }}
          initial={{ opacity: 0, scale: 0.2 }}
          animate={{
            x: bubble.xKeyframes,
            y: bubble.yKeyframes,
            opacity: [0, 1, 0.9, 0], // Gentle fade-in as it rises, soft dissolve at target
            scale: [0.2, 1.15, 1, 0], // Buoyant "pop" expansion when floating upward
          }}
          exit={{ opacity: 0, scale: 0 }}
          transition={{
            duration: 1.8 + bubble.id * 0.15, // Softer, longer duration for floatiness
            ease: [0.25, 0.1, 0.25, 1], // Custom cubic-bezier for weightless momentum
            times: [0, 0.5, 1], // Equal keyframe distribution across timeline
            delay: bubble.delay,
          }}
        />
      ))}
    </motion.div>
  );
};

export default React.memo(CreditStreamAnimation);